import "./page-hierarchy.scss";
const PageHierarchy = () => {
    const path = window.location.pathname;
    const pathParts = path.split("/").splice(1);
    const partPathToText = {
        "stock-management": "Stock Management",
        "ice-cream": "Ice Cream",
        "consumption": "Consumption",
        "forecast": "Forecast",
        "product": "Per product",
        "other-products": "Other products",
        "amount-available-per-product": "Amount available per product",
        "settings": "Settings",
        "other": "Other",
        "shop-management": "Shop management",
        "user-management": "User management",
        "stock": "Stock",
        "dashboard": "Dashboard",
        "activity-log": "Activity log"
    };
    const descriptions = {
        "shop-management": "Manage your shops here",
        "user-management": "Manage your team members and their account permissions here",
        "activity-log": "View the activity log here"
    }

    const pageDescription = descriptions[pathParts[pathParts.length -1 ]]
    return (
        <div className="page-hierarchy">
            {pathParts.map(part => partPathToText[part]).join(" > ")}
            {
                pageDescription && <div className="page-hierarchy__description">
                {pageDescription}
            </div>
            }
        </div>
    );
};

export default PageHierarchy;
